import { render, staticRenderFns } from "./ProductImgUpload.vue?vue&type=template&id=4a0e1f36&scoped=true"
import script from "./ProductImgUpload.vue?vue&type=script&lang=js"
export * from "./ProductImgUpload.vue?vue&type=script&lang=js"
import style0 from "./ProductImgUpload.vue?vue&type=style&index=0&id=4a0e1f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e1f36",
  null
  
)

export default component.exports